<template>
  <div class="contentA">
    <div class="content-top">
      <span :class="type == '1'? 'active' : ''" @click="changeType('1')">考试统计</span>
      <span :class="type == '2'? 'active' : ''" @click="changeType('2')">试卷管理</span>
      <span :class="type == '3'? 'active' : ''" @click="changeType('3')">题库管理</span>
    </div>
    <div class="content-box">
    <div v-if="type=='1'">
     <examStatisticsWx></examStatisticsWx>
  
        
 </div>

      <exa-Paper-Ment v-else-if="type == '2'"></exa-Paper-Ment>
      <exercise-Management v-else-if="type == '3'"></exercise-Management>
    </div>
  </div>
</template>

<script>
import util from '../../../untils/util'
  import examStatistics from './components/examStatistics.vue'
    import examStatisticsWx from './components/examStatisticsWx.vue'
  import exaPaperMent from './components/exaPaperMent.vue'
  import exerciseManagement from './components/exerciseManagement.vue'
  export default {
    components: {
      examStatistics,
      examStatisticsWx,
      exaPaperMent,
      exerciseManagement
      },
    data() {
      return {
        type: '1',
        projectId:util.session.get('groupId'),
      }
    },
    mounted() {
      this.type = this.$route.query.type||'1'
    },
    methods: {
      changeType(type){
        this.type = type
        if(type=='2'){
          this.$router.push({
            path:'examRunWx',
            query:{
              type:'2'
            }
          })
        }
        if(type=='1'){
          this.$router.push({
            path:'examRunWx',
            query:{
              type:'1'
            }
          })
        }
        if(type=='3'){
          this.$router.push({
            path:'examRunWx',
            query:{
              type:'3'
            }
          })
        }
      }
    },
  }
</script>

<style scoped>
.contentA{
  /* padding: 1vh 1vw; */
  padding: 1vh 24px 10px 8px;
  height: 100%;
  overflow: auto;
}
.content-top{
  height: 56px;
  border-radius: 6px;
  background-color: #fff;
  text-align: left;
  margin-bottom: 8px;
}
.content-top > span {
  margin-left: 18px;
  padding-bottom: 18px;
  line-height: 56px;
  cursor: pointer;
}
.content-box{
  height: calc(100% - 64px);
  overflow: auto;
}
.active{
  border-bottom: 2px solid #4D6EB1;
}
</style>